import axios from 'axios';
import { getApiBase } from './apiBase';

const API = getApiBase();

export const aiLegacyBookApi = {
  getDraft: (treeId) =>
    axios.get(`${API}/trees/${treeId}/ai-book-draft`).then((r) => r.data),

  prepare: (treeId) =>
    axios.post(`${API}/trees/${treeId}/ai-book-draft/prepare`).then((r) => r.data),

  updateSections: (treeId, sections) =>
    axios.patch(`${API}/trees/${treeId}/ai-book-draft`, { sections }).then((r) => r.data),

  markReviewed: (treeId) =>
    axios.post(`${API}/trees/${treeId}/ai-book-draft/mark-reviewed`).then((r) => r.data),
};

export default aiLegacyBookApi;
